import type { FlexibleColumnLayoutType, ManifestSettingsType } from './types';

export enum PageTypeV2 {
    ObjectPage = 'ObjectPage',
    ListReport = 'ListReport',
    OverviewPage = 'OverviewPage',
    CustomPage = 'CustomPage',
    AnalyticalListPage = 'AnalyticalListPage'
}

export enum PageTypeV4 {
    ObjectPage = 'ObjectPage',
    ListReport = 'ListReport',
    CustomPage = 'CustomPage',
    FPMCustomPage = 'FPMCustomPage',
    AnalyticalListPage = 'AnalyticalListPage'
}

export type PageType = PageTypeV2 | PageTypeV4;
export const PageType = { ...PageTypeV2, ...PageTypeV4 };

export const PAGETYPE_VIEW_EXTENSION_TEMPLATE_MAP: Map<PageTypeV2, string> = new Map([
    [PageTypeV2.ListReport, 'sap.suite.ui.generic.template.ListReport.view.ListReport'],
    [PageTypeV2.AnalyticalListPage, 'sap.suite.ui.generic.template.AnalyticalListPage.view.AnalyticalListPage'],
    [PageTypeV2.ObjectPage, 'sap.suite.ui.generic.template.ObjectPage.view.Details']
]);

export interface PageConfig {
    $schema?: string;
}

export interface CustomPageConfig extends PageConfig {
    $filePath?: string;
}

export interface PageBase {
    name?: string;
    entitySet?: string;
    contextPath?: string;
    navigationProperty?: string;
    config?: PageConfig;
    navigation?: { [property: string]: string | object };
    variantManagement?: string;
    defaultLayoutType?: FlexibleColumnLayoutType;
}

export enum FioriElementsVersion {
    v2 = 'v2',
    v4 = 'v4'
}
export enum OdataVersion {
    v2 = 'v2',
    v4 = 'v4'
}
export interface Target {
    fioriElements?: FioriElementsVersion;
    odata?: OdataVersion;
}

export interface PagesBase {
    [key: string]: PageBase;
}
export interface SapUiGenericAppPageSettings {
    [key: string]: ManifestSettingsType;
}

export interface SapUiGenericAppPage {
    entitySet: string;
    navigationProperty?: string;
    component: {
        name: string;
        settings?: SapUiGenericAppPageSettings;
    };
    pages?: SapUiGenericAppPage[] | { [pageId: string]: SapUiGenericAppPage };
}

export interface SapUiGenericAppPageMap {
    [key: string]: SapUiGenericAppPage;
}

export interface SapUiGenericApp {
    pages: SapUiGenericAppPage[] | SapUiGenericAppPageMap;
    _version?: string;
    settings?: object;
}
